import { type System } from '@ecs/world';
import type { TimeScaleResource } from '@game/scenes/characterPrototype/types';

export function createTimeScaleSystem(): System {
	return ({ delta, world }) => {
		const timescale = world.getResource<TimeScaleResource>('timescale');
		if (!timescale) return;
		if (timescale.boostRemaining > 0) {
			timescale.boostRemaining = Math.max(0, timescale.boostRemaining - delta);
		}
		const boosted = timescale.boostRemaining > 0 ? timescale.boostValue : timescale.base;
		timescale.value = Math.max(timescale.base, boosted);
	};
}


